@if (dialog.title) {
  <h2 mat-dialog-title
    class="title">
    {{dialog.title}}
  </h2>
}

@if (dialog.content) {
  <div mat-dialog-content
    class="content"
    [innerHTML]="dialog.content"></div>
}

<div mat-dialog-actions
  class="action">

  <button class="dialog-button submit"
    mat-raised-button
    color="accent"
  (click)="ok()">{{'BUTTONS.OK'| translate}}</button>

  @if (dialogRef.componentInstance.dialog.showCancelButton) {
    <button
      mat-raised-button
      mat-dialog-close
      (click)="cancel()"
    class="dialog-button">{{'BUTTONS.CANCEL'| translate}}</button>
  }
</div>
